import React from "react";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

const APP_LABELS = {
    word_wheel_quest: "Word Wheel Quest",
    jigsaw_muse: "Jigsaw Muse",
    sliding_puzzle_quest: "Sliding Puzzle Quest",
};

const PLATFORM_LABELS = {
    ios: "iOS",
    android: "Android",
};

function formatTime(value) {
    const millis = Number(value);
    if (!Number.isFinite(millis) || millis <= 0) {
        return "—";
    }
    return new Date(millis).toLocaleString();
}

export function getAppReviewColumns(navigate) {
    return [
        {
            field: "user",
            headerName: "User",
            flex: 1.4,
            minWidth: 240,
            sortable: false,
            valueGetter: (_value, row) => {
                const name = typeof row?.name === "string" ? row.name.trim() : "";
                const email = typeof row?.email === "string" ? row.email.trim() : "";
                return [name, email].filter(Boolean).join(" ") || "—";
            },
            renderCell: (params) => {
                const name = typeof params.row?.name === "string" ? params.row.name.trim() : "";
                const email = typeof params.row?.email === "string" ? params.row.email.trim() : "";
                const openUser = () => {
                    if (!params.row?.cloudUserId) return;
                    navigate(`/admin/account/subscription/${params.row.cloudUserId}`);
                };
                return (
                    <Box
                        onClick={openUser}
                        sx={{
                            cursor: "pointer",
                            color: "#1976d2",
                            textDecoration: "underline",
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                            lineHeight: 1.35,
                            py: 0.5,
                        }}
                    >
                        {name || email ? (
                            <>
                                {name ? (
                                    <Box component="span" sx={{ display: "block" }}>
                                        {name}
                                    </Box>
                                ) : null}
                                {email ? (
                                    <Box
                                        component="span"
                                        sx={{
                                            display: "block",
                                            wordBreak: "break-all",
                                            color: name ? "text.secondary" : "#1976d2",
                                            textDecoration: name ? "none" : "underline",
                                            fontSize: name ? "0.8125rem" : undefined,
                                        }}
                                    >
                                        {email}
                                    </Box>
                                ) : null}
                            </>
                        ) : (
                            "—"
                        )}
                    </Box>
                );
            },
        },
        {
            field: "appCode",
            headerName: "App",
            flex: 1,
            minWidth: 180,
            sortable: false,
            valueGetter: (_value, row) => APP_LABELS[row?.appCode] || row?.appCode || "—",
        },
        {
            field: "platform",
            headerName: "Platform",
            width: 120,
            sortable: false,
            valueGetter: (_value, row) => PLATFORM_LABELS[row?.platform] || row?.platform || "—",
        },
        {
            field: "promptedAt",
            headerName: "Time",
            flex: 1,
            minWidth: 200,
            sortable: false,
            valueGetter: (_value, row) => formatTime(row?.promptedAt),
        },
    ];
}
